/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaFolder model module.
 * @module model/AqaFolder
 * @version v0
 */
export default class AqaFolder {
  /**
   * Constructs a new <code>AqaFolder</code>.
   * @alias module:model/AqaFolder
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaFolder</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaFolder} obj Optional instance to populate.
   * @return {module:model/AqaFolder} The populated <code>AqaFolder</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaFolder();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('umbrellaIds'))
        obj.umbrellaIds = ApiClient.convertToType(data['umbrellaIds'], ['String']);
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Number');
      if (data.hasOwnProperty('createdBy'))
        obj.createdBy = ApiClient.convertToType(data['createdBy'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('creadtedById'))
        obj.creadtedById = ApiClient.convertToType(data['creadtedById'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaFolder.prototype.id = undefined;

/**
 * @member {Array.<String>} umbrellaIds
 */
AqaFolder.prototype.umbrellaIds = undefined;

/**
 * @member {Number} dateCreated
 */
AqaFolder.prototype.dateCreated = undefined;

/**
 * @member {String} createdBy
 */
AqaFolder.prototype.createdBy = undefined;

/**
 * @member {String} name
 */
AqaFolder.prototype.name = undefined;

/**
 * @member {String} creadtedById
 */
AqaFolder.prototype.creadtedById = undefined;

